/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CtmsCategoryRespVo } from './CtmsCategoryRespVo';
import {
    CtmsCategoryRespVoFromJSON,
    CtmsCategoryRespVoFromJSONTyped,
    CtmsCategoryRespVoToJSON,
    CtmsCategoryRespVoToJSONTyped,
} from './CtmsCategoryRespVo';

/**
 * 
 * @export
 * @interface ResponseCtmsCategoryRespVo
 */
export interface ResponseCtmsCategoryRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCtmsCategoryRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCtmsCategoryRespVo
     */
    message?: string;
    /**
     * 
     * @type {CtmsCategoryRespVo}
     * @memberof ResponseCtmsCategoryRespVo
     */
    data?: CtmsCategoryRespVo;
}

/**
 * Check if a given object implements the ResponseCtmsCategoryRespVo interface.
 */
export function instanceOfResponseCtmsCategoryRespVo(value: object): value is ResponseCtmsCategoryRespVo {
    return true;
}

export function ResponseCtmsCategoryRespVoFromJSON(json: any): ResponseCtmsCategoryRespVo {
    return ResponseCtmsCategoryRespVoFromJSONTyped(json, false);
}

export function ResponseCtmsCategoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCtmsCategoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CtmsCategoryRespVoFromJSON(json['data']),
    };
}

export function ResponseCtmsCategoryRespVoToJSON(json: any): ResponseCtmsCategoryRespVo {
    return ResponseCtmsCategoryRespVoToJSONTyped(json, false);
}

export function ResponseCtmsCategoryRespVoToJSONTyped(value?: ResponseCtmsCategoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CtmsCategoryRespVoToJSON(value['data']),
    };
}

